import React, { useEffect } from 'react';
import { useTheme } from './ThemeProvider';

const LoadingScreen = ({ onFinished }) => {
  const { theme } = useTheme();

  useEffect(() => {
    const timer = setTimeout(() => {
      onFinished();
    }, 2400);

    return () => clearTimeout(timer);
  }, [onFinished]);

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center animate-loader-exit pointer-events-none transition-colors duration-0 overflow-hidden">
      {/* White Animated Background */}
      <div className="absolute inset-0 bg-white">
        <div className="absolute inset-0 bg-[linear-gradient(45deg,#ffffff,#f3f4f6,#ffffff)] bg-[length:200%_200%] animate-[gradientMove_3s_ease_infinite]"></div>
      </div>

      {/* Subtle Radial Burst */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(0,0,0,0.03)_0%,transparent_70%)] animate-pulse"></div>

      <div className="relative flex flex-col items-center justify-center">
        <div className="relative w-96 h-96 animate-breathe">
          <img
            src="https://universal-service.sfo3.cdn.digitaloceanspaces.com/logo/Project%20Lock%20Logo%20Final%20.%20ai-05.png"
            alt="Loading..."
            className="w-full h-full object-contain filter drop-shadow-lg dark:drop-shadow-[0_0_15px_rgba(255,255,255,0.1)]"
          />
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
